module.exports = __webpack_public_path__ + "img/Number=87.0ab043d3.png";